module.exports = __webpack_public_path__ + "./fonts/ReneBieder-CamptonThin.otf";